import type { SubscriptionType } from "common/types";

import { ACTIVATE_PLAN_CONFIG, PLAN_COVER_IMAGES } from "../../constants";
import ActivatePlanCard from "./ActivatePlanCard";
import UpsellCard from "./UpsellCard";

interface ActivatePlanLayoutProps {
  plan: SubscriptionType;
  onActivate: () => void;
}

export default function ActivatePlanLayout({
  plan,
  onActivate,
}: ActivatePlanLayoutProps) {
  const { upsellCards } = ACTIVATE_PLAN_CONFIG[plan];

  return (
    <section className="grid lg:grid-cols-2 gap-x-2">
      <div className="flex flex-col gap-2.5">
        <ActivatePlanCard plan={plan} onActivate={onActivate} />

        <div className="hidden lg:grid lg:grid-cols-2 gap-2.5">
          {upsellCards.map((card) => (
            <UpsellCard key={card.id} {...card} />
          ))}
        </div>
      </div>

      <img
        src={PLAN_COVER_IMAGES[plan]}
        className="hidden lg:block rounded-3xl w-full h-full object-cover"
        alt=""
      />
    </section>
  );
}
